import { useRef } from "react"

export default function (arr) {
  const selection = useRef(arr[Math.floor(Math.random() * arr.length)])
  return selection.current
}
